import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/icon/icon22.png';
const _withScopeId = n => (_pushScopeId("data-v-c1721ccc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pl30 pr30 pb40"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr5",
  src: _imports_0
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text_black"
}, "待办事项", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = {
  class: "account mt20"
};
const _hoisted_6 = {
  style: {
    "width": "20%"
  },
  class: "flex_FSBC text_white"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "账户钱包余额", -1));
const _hoisted_8 = {
  style: {
    "width": "20%"
  },
  class: "flex_FSBC mt15 text_white"
};
const _hoisted_9 = {
  class: "account_price"
};
const _hoisted_10 = {
  key: 0,
  class: "account_price_unit"
};
const _hoisted_11 = {
  class: "count flex_FSBC mt15"
};
const _hoisted_12 = {
  class: "count_item flex_size_1 mr15"
};
const _hoisted_13 = {
  class: "count_item_main"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "count_item_label mt15"
}, "发货总次数", -1));
const _hoisted_15 = {
  class: "count_item_title"
};
const _hoisted_16 = {
  class: "flex mb15"
};
const _hoisted_17 = {
  class: "count_item_text mr30"
};
const _hoisted_18 = {
  class: "count_item_text"
};
const _hoisted_19 = {
  class: "count_item flex_size_1 mr15"
};
const _hoisted_20 = {
  class: "count_item_main"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "count_item_label mt15"
}, "总运单数", -1));
const _hoisted_22 = {
  class: "count_item_title"
};
const _hoisted_23 = {
  class: "flex mb15"
};
const _hoisted_24 = {
  class: "count_item_text mr30"
};
const _hoisted_25 = {
  class: "count_item_text"
};
const _hoisted_26 = {
  class: "count_item flex_size_1"
};
const _hoisted_27 = {
  class: "count_item_main"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "count_item_label mt15"
}, "运单总费用", -1));
const _hoisted_29 = {
  class: "count_item_title"
};
const _hoisted_30 = {
  class: "mb15"
};
const _hoisted_31 = {
  class: "flex"
};
const _hoisted_32 = {
  class: "count_item_text mr30"
};
const _hoisted_33 = {
  class: "count_item_text"
};
const _hoisted_34 = {
  class: "flex"
};
const _hoisted_35 = {
  class: "count_item_text mr30"
};
const _hoisted_36 = {
  class: "count_item_text"
};
const _hoisted_37 = {
  class: "mt15 month_data flex"
};
const _hoisted_38 = {
  class: "flex_size_1 flex_FSBS pr35"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "上月发货总数", -1));
const _hoisted_40 = {
  class: "month_data_text"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "本月发货总数", -1));
const _hoisted_42 = {
  class: "month_data_text"
};
const _hoisted_43 = {
  class: "flex_size_1 pl35 pr35 flex_FSBS"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "上月运单数", -1));
const _hoisted_45 = {
  class: "month_data_text"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "本月运单数", -1));
const _hoisted_47 = {
  class: "month_data_text"
};
const _hoisted_48 = {
  class: "flex_size_1 pl35"
};
const _hoisted_49 = {
  class: "flex_FSBC"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "上月运单总额", -1));
const _hoisted_51 = {
  class: "month_data_text"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "上月服务费额", -1));
const _hoisted_53 = {
  class: "month_data_text"
};
const _hoisted_54 = {
  class: "flex_FSBC mt30"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "本月运单总额", -1));
const _hoisted_56 = {
  class: "month_data_text"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "month_data_label"
}, "本月服务费额", -1));
const _hoisted_58 = {
  class: "month_data_text"
};
const _hoisted_59 = {
  class: "trans_history mt15"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "运输历史", -1));
const _hoisted_61 = {
  class: "flex flexW"
};
const _hoisted_62 = {
  class: "mt15 history_data"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title pl25"
}, "历史数据查询", -1));
const _hoisted_64 = {
  class: "flex_FEC mt10 pl25",
  style: {
    "width": "20%"
  }
};
const _hoisted_65 = {
  class: "history_data_list"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex history_data_list_header"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "flex_size_1"
}, "发货总数"), /*#__PURE__*/_createElementVNode("p", {
  class: "flex_size_1"
}, "运单总数"), /*#__PURE__*/_createElementVNode("p", {
  class: "flex_size_1"
}, "运单总额")], -1));
const _hoisted_67 = {
  class: "flex history_data_list_main"
};
const _hoisted_68 = {
  class: "flex_size_1"
};
const _hoisted_69 = {
  class: "flex_size_1"
};
const _hoisted_70 = {
  class: "flex_size_1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_View = _resolveComponent("View");
  const _component_Hide = _resolveComponent("Hide");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "flex_FSC personalcenter pointer mt20",
    onClick: _cache[0] || (_cache[0] = () => $setup.toPage('/layout/backlog'))
  }, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("p", {
    class: "pointer",
    onClick: _cache[1] || (_cache[1] = () => $setup.toPage('/layout/recharge'))
  }, "充值")]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, [_createTextVNode(_toDisplayString($setup.data.isShow ? $setup.data.amount : $setup.data.amount.toString().replaceAll(/./g, "*") + "*") + " ", 1), $setup.data.isShow ? (_openBlock(), _createElementBlock("span", _hoisted_10, "元")) : _createCommentVNode("", true)]), _createVNode(_component_el_icon, {
    class: "ml10 pointer",
    onClick: _cache[2] || (_cache[2] = () => $setup.setIsShow(_ctx.index))
  }, {
    default: _withCtx(() => [$setup.data.isShow ? (_openBlock(), _createBlock(_component_View, {
      key: 0
    })) : (_openBlock(), _createBlock(_component_Hide, {
      key: 1
    }))]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_hoisted_14, _createElementVNode("p", _hoisted_15, _toDisplayString($setup.data.webDemandDataStatisticsVO?.totalDemand) + " 次 ", 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, " 去年发货数 " + _toDisplayString($setup.data.webDemandDataStatisticsVO?.lastYearSDemand) + " 次 ", 1), _createElementVNode("p", _hoisted_18, " 今年发货数 " + _toDisplayString($setup.data.webDemandDataStatisticsVO?.thisYearSDemand) + " 次 ", 1)])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_hoisted_21, _createElementVNode("p", _hoisted_22, _toDisplayString($setup.data.webOrderDataStatisticsVO?.totalOrderQuantity) + " 单 ", 1)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("p", _hoisted_24, " 去年运单数 " + _toDisplayString($setup.data.webOrderDataStatisticsVO.numberOfOrdersLastYear) + " 单 ", 1), _createElementVNode("p", _hoisted_25, " 今年运单数 " + _toDisplayString($setup.data.webOrderDataStatisticsVO?.numberOfOrdersThisYear) + " 单 ", 1)])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, [_hoisted_28, _createElementVNode("p", _hoisted_29, _toDisplayString($setup.data.webOrderDataStatisticsVO?.totalOrderAmount / 100) + " 元 ", 1)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("p", _hoisted_32, " 去年运单总额 " + _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfOrdersLastYear / 100) + " 元 ", 1), _createElementVNode("p", _hoisted_33, " 今年运单总额 " + _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfOrdersThisYear / 100) + " 元 ", 1)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("p", _hoisted_35, " 去年服务费额 " + _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfServiceFeeLastYear / 100) + " 元 ", 1), _createElementVNode("p", _hoisted_36, " 今年服务费额 " + _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfServiceFeeThisYear / 100) + " 元 ", 1)])])])])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, [_hoisted_39, _createElementVNode("p", _hoisted_40, _toDisplayString($setup.data.webDemandDataStatisticsVO?.lastMonthSDemand) + " 次 ", 1)]), _createElementVNode("div", null, [_hoisted_41, _createElementVNode("p", _hoisted_42, _toDisplayString($setup.data.webDemandDataStatisticsVO?.thisMonthSDemand) + " 次 ", 1)])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, [_hoisted_44, _createElementVNode("p", _hoisted_45, _toDisplayString($setup.data.webOrderDataStatisticsVO?.numberOfOrdersLastMonth) + " 单 ", 1)]), _createElementVNode("div", null, [_hoisted_46, _createElementVNode("p", _hoisted_47, _toDisplayString($setup.data.webOrderDataStatisticsVO?.numberOfOrdersThisMonth) + " 次 ", 1)])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", null, [_hoisted_50, _createElementVNode("p", _hoisted_51, _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfOrdersLastMonth / 100) + " 元 ", 1)]), _createElementVNode("div", null, [_hoisted_52, _createElementVNode("p", _hoisted_53, _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfServiceFeeLastMonth / 100) + " 元 ", 1)])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", null, [_hoisted_55, _createElementVNode("p", _hoisted_56, _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfOrdersThisMonth / 100) + " 元 ", 1)]), _createElementVNode("div", null, [_hoisted_57, _createElementVNode("p", _hoisted_58, _toDisplayString($setup.data.webOrderDataStatisticsVO?.amountOfServiceFeeThisMonth / 100) + " 元 ", 1)])])])]), _createElementVNode("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", _hoisted_61, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.webTransportHistoryVO, item => {
    return _openBlock(), _createElementBlock("p", {
      class: "mt10 mr10 trans_history_tag",
      key: item
    }, _toDisplayString(item), 1);
  }), 128))])]), _createElementVNode("div", _hoisted_62, [_hoisted_63, _createElementVNode("div", _hoisted_64, [_createVNode(_component_el_config_provider, {
    locale: $setup.zhCn
  }, {
    default: _withCtx(() => [_createVNode(_component_el_date_picker, {
      modelValue: $setup.data.times,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.data.times = $event),
      type: "daterange",
      clearable: false,
      editable: false,
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      format: "YYYY-MM-DD",
      "value-format": "YYYY-MM-DD",
      onChange: $setup.changeDate
    }, null, 8, ["modelValue", "onChange"])]),
    _: 1
  }, 8, ["locale"]), _createVNode(_component_el_button, {
    class: "ml20",
    type: "primary",
    onClick: $setup.historicalDataQuery
  }, {
    default: _withCtx(() => [_createTextVNode("查询")]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_65, [_hoisted_66, _createElementVNode("div", _hoisted_67, [_createElementVNode("p", _hoisted_68, _toDisplayString($setup.data.totalDemand) + " 次", 1), _createElementVNode("p", _hoisted_69, _toDisplayString($setup.data.totalOrderQuantity) + " 单", 1), _createElementVNode("p", _hoisted_70, _toDisplayString($setup.data.totalOrderAmount / 100) + " 元", 1)])]), _createVNode(_component_el_button, {
    text: "",
    type: "primary",
    class: "pl25 mt40",
    onClick: _cache[4] || (_cache[4] = () => $setup.toPage('/layout/statementaccount'))
  }, {
    default: _withCtx(() => [_createTextVNode("对账单查看")]),
    _: 1
  })])]);
}